<template>
  <app-input
    ref="input"
    :model-value="valueFormattedForCurrentLanguage"
    :disable="disableComputed"
    :readonly="readonlyComputed"
    :form-state-inheritance-disabled="formStateInheritanceDisabled"
    date
    @update:model-value="onValueChange"
  >
    <template v-if="!disableComputed && !readonlyComputed" #append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy ref="popup" cover transition-show="scale" transition-hide="scale">
          <q-date :model-value="modelValue" mask="YYYY-MM-DD" @update:model-value="onValueChangeInApiFormat">
            <div class="row items-center justify-end gap-1">
              <app-button size="sm" :label="$t('_RSFAP_SHARED_CALENDAR_CLEAR')" @click="clear" />
              <app-button size="sm" :label="$t('_RSFAP_SHARED_CALENDAR_TODAY')" @click="setToday" />
              <q-space />
              <app-button size="sm" v-close-popup :label="$t('_RSFAP_SHARED_CLOSE')" />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
  </app-input>
</template>

<script setup>
import { computed, ref } from "vue"

import { useFieldsetState } from "@/composables/useFieldsetState.js"

import * as dates from "@/services/dates.js"

const props = defineProps({
  modelValue: {
    type: String,
    default: null
  },
  disable: Boolean,
  readonly: Boolean,
  formStateInheritanceDisabled: Boolean
})

const emit = defineEmits(["update:modelValue"])

const { disableComputed, readonlyComputed } = useFieldsetState(props)

const input = ref(null)
const popup = ref(null)

const valueFormattedForCurrentLanguage = computed(() => dates.getLocalizedStringFromDateTime(props.modelValue))

const onValueChange = (value) => {
  popup.value.hide()

  if (value == null || value === "") {
    emit("update:modelValue", null)
    return
  }

  if (dates.isDateStringValid(value)) {
    emit("update:modelValue", dates.getApiStringFromDateString(value))
  }
}

const onValueChangeInApiFormat = (value) => {
  emit("update:modelValue", value)
}

const clear = () => onValueChange(null)
const setToday = () => onValueChangeInApiFormat(dates.getApiStringFromDate(new Date(), true))

defineExpose({
  validate: () => input.value.validate()
})
</script>
